/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  ListGcpKmsKeysRequest,
  ListGcpKmsKeysSecurity,
} from "../models/operations/listgcpkmskeys.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  buildListGcpKmsKeysQuery,
  ListGcpKmsKeysQueryData,
  prefetchListGcpKmsKeys,
  queryKeyListGcpKmsKeys,
} from "./listGcpKmsKeys.core.js";
export {
  buildListGcpKmsKeysQuery,
  type ListGcpKmsKeysQueryData,
  prefetchListGcpKmsKeys,
  queryKeyListGcpKmsKeys,
};

export type ListGcpKmsKeysQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * listGcpKmsKeys externalKeys
 *
 * @remarks
 * List the organization's GCP KMS external keys. Requires org:read.
 */
export function useListGcpKmsKeys(
  request?: ListGcpKmsKeysRequest | undefined,
  security?: ListGcpKmsKeysSecurity | undefined,
  options?: QueryHookOptions<ListGcpKmsKeysQueryData, ListGcpKmsKeysQueryError>,
): UseQueryResult<ListGcpKmsKeysQueryData, ListGcpKmsKeysQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildListGcpKmsKeysQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * listGcpKmsKeys externalKeys
 *
 * @remarks
 * List the organization's GCP KMS external keys. Requires org:read.
 */
export function useListGcpKmsKeysSuspense(
  request?: ListGcpKmsKeysRequest | undefined,
  security?: ListGcpKmsKeysSecurity | undefined,
  options?: SuspenseQueryHookOptions<
    ListGcpKmsKeysQueryData,
    ListGcpKmsKeysQueryError
  >,
): UseSuspenseQueryResult<ListGcpKmsKeysQueryData, ListGcpKmsKeysQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildListGcpKmsKeysQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setListGcpKmsKeysData(
  client: QueryClient,
  queryKeyBase: [parameters: { gramSession?: string | undefined }],
  data: ListGcpKmsKeysQueryData,
): ListGcpKmsKeysQueryData | undefined {
  const key = queryKeyListGcpKmsKeys(...queryKeyBase);

  return client.setQueryData<ListGcpKmsKeysQueryData>(key, data);
}

export function invalidateListGcpKmsKeys(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "externalKeys", "listGcpKms", ...queryKeyBase],
  });
}

export function invalidateAllListGcpKmsKeys(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "externalKeys", "listGcpKms"],
  });
}
